module.exports = __webpack_public_path__ + "img/Banner RC.e327563e.png";